import React from 'react'


const NoMatch = () => {

    const Banner = {
        backgroundImage: 'url("/noroute.jpg")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100vh'
    }

    return (
        
        <div className='WideBanner' style={ Banner }>

            <p id='Denied'>The page you requested was not found</p>
  
        </div>
            
    )
    
}

export default NoMatch


// WEBPACK FOOTER //
// ./src/components/etc/Nomatch.js